import * as React from 'react';
import Common from '../../utilities/common';
import { Entity } from '../../utilities/Permisos';
import $ from "jquery";
import { Button, Card, CardContent, Grid, List, ListItem, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material';
import DoDisturbAltOutlinedIcon from '@mui/icons-material/DoDisturbAltOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import SentimentDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentDissatisfiedOutlined';

export interface IFeatureManagerProps {
    children: string | JSX.Element | JSX.Element[];
    entidad: Entity;
    operacion: string;
    showBuyOption?: boolean;
}

export interface IFeatureManagerState {
    hasAccess: boolean;
    checking: boolean;
    licensesByFeature: any[];
}

export default class FeatureManager extends React.Component<IFeatureManagerProps, IFeatureManagerState> {
    public constructor(props: IFeatureManagerProps) {
        super(props);

        this.state = {
            hasAccess: false,
            checking: true,
            licensesByFeature: []
        }
    }

    componentDidMount(): void {
        //this.CheckAccess();
        //this.GetLicensesByFeature();
    }

    public render(): React.ReactElement<{}> {
        return (
             <React.Fragment>
                {
                    this.props.children
                }
            </React.Fragment>
        )
    }

    /*public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                {
                    this.state.hasAccess && !this.state.checking && (
                        <React.Fragment>
                            {
                                this.props.children
                            }
                        </React.Fragment>
                    )
                }
                {
                    !this.state.hasAccess && !this.state.checking && this.props.showBuyOption && (
                        <React.Fragment>
                            <div className='noLicense'>
                                <Stack direction={'row'} justifyContent={'flex-start'} alignItems={'center'} gap={'20px'}>
                                    <DoDisturbAltOutlinedIcon style={{fontSize: '140px'}} className='animate__animated animate__pulse'/>
                                    <Typography variant='h4'>
                                        No tiene acceso a esta característica
                                    </Typography>
                                </Stack>
                                <Typography variant='body2' style={{textAlign: 'left', marginTop: '40px'}}>
                                    Su licencia actual no incluye la característica a la que intenta acceder.
                                </Typography>
                                <Typography variant='body2' style={{textAlign: 'left'}}>
                                    ¿Necesita esta característica? Contrate una licencia superior para acceder a más funcionalidades:
                                </Typography>
                                <Grid container spacing={3} className='licensesList'>
                                    {
                                        this.state.licensesByFeature.map((item: any, index: number) => {
                                            return (
                                                <Grid item xs={Math.round(12 / this.state.licensesByFeature.length)} key={`license-${index}`}>
                                                    <Card>
                                                        <CardContent>
                                                            <Typography variant='h5' fontWeight={'bold'}>
                                                                {
                                                                    item.licencia
                                                                }
                                                            </Typography>
                                                            <Typography variant='h3' color={'primary'} marginTop={'20px'}>
                                                                {
                                                                    `${item.price.toLocaleString()}€`
                                                                }
                                                            </Typography>
                                                            <Typography variant='body2'>mensual</Typography>
                                                            <Button variant='contained' style={{marginTop: '20px'}}>
                                                                Comprar ahora
                                                            </Button>
                                                            <Typography variant='body2' marginTop={'40px'} fontWeight={'bold'} textAlign={'left'}>Características incluidas:</Typography>
                                                            <List>
                                                                {
                                                                    item.features.map((feature: any, featureIndex: number) => {
                                                                        return (
                                                                            <ListItem disablePadding key={`license-${index}-feature-${featureIndex}`}>
                                                                                <ListItemIcon>
                                                                                    <CheckOutlinedIcon color='primary'/>
                                                                                </ListItemIcon>
                                                                                <ListItemText primary={<Typography variant='caption'>{`${feature.name}: ${feature.operations}`}</Typography>} />
                                                                            </ListItem>
                                                                        )
                                                                    })
                                                                }
                                                            </List>
                                                        </CardContent>
                                                    </Card>
                                                </Grid>
                                            )
                                        })
                                    }
                                </Grid>
                            </div>
                        </React.Fragment>
                    )
                }
            </React.Fragment>
        )
    }*/

    private CheckAccess() {
        let url = `${Common.END_POINT}/features/check`;

        var obj = {
            entidadId: this.props.entidad,
            operacion: this.props.operacion
        }
        
        $.ajax((
            {
                url: url,
                type: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(obj),
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: boolean) => {
            this.setState(
                {
                    hasAccess: response,
                    checking: false
                }
            )
        }).fail(( jqXHR, textStatus, errorThrow) => {
            if(jqXHR.status == 401) {
                window.location.href = "/login";
            }
        })
    }

    private GetLicensesByFeature() {
        let url = `${Common.END_POINT}/features/byfeature`;

        var obj = {
            entidadId: this.props.entidad,
            operacion: this.props.operacion
        }
        
        $.ajax((
            {
                url: url,
                type: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(obj),
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const licencias: any[] = [];

            for(var i = 0; i < response.length; i++) {
                const licencia = licencias.find((item: any) => {
                    return item.licencia == response[i].name;
                });

                if(licencia == null) {
                    licencias.push(
                        {
                            licencia: response[i].name,
                            price: response[i].price,
                            features: [
                                {
                                    name: response[i].entidad,
                                    operations: response.filter((item: any) => {
                                        return item.name == response[i].name && item.entidad == response[i].entidad;
                                    }).map((value: any) => value.operacion).toString().replaceAll(',', ', ')
                                }
                            ]
                        }
                    );
                }
            }

            this.setState(
                {
                    licensesByFeature: licencias
                }
            )
        }).fail(( jqXHR, textStatus, errorThrow) => {
            if(jqXHR.status == 401) {
                window.location.href = "/login";
            }
        })
    }
}